import axios from "axios";
import { API_BASE_URL } from "../const";

export default axios.create({
  //baseURL: "https://mainapi.poldentech.ru/",
  //baseURL: "https://testapi.poldentech.ru/",
  baseURL: API_BASE_URL,
  config: {headers: {'Content-Type': 'application/json'}, withCredentials: true}
});


// WEBPACK FOOTER //
// ./src/api/BaseApi.js